var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "section" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "my-textblock" }, [
          _c("h1", { staticClass: "title" }, [_vm._v("Privacy Statement")]),
          _c("br"),
          _c("h2", { staticClass: "subtitle" }, [
            _vm._v("SECTION 1 – WHAT DO WE DO WITH YOUR INFORMATION?")
          ]),
          _c("p", [
            _vm._v(
              "When you browse our store, we also automatically receive your computer’s internet protocol (IP) address in order to provide us with information that helps us learn about your browser and operating system. We may also collect the personal information you give us such as your name, address and email address."
            )
          ]),
          _c("p", [
            _vm._v(
              "Email marketing (if applicable): With your permission, we may contact you and send you emails about our site, new products and other updates."
            )
          ]),
          _c("h2", { staticClass: "subtitle" }, [_vm._v("CONSENT")]),
          _c("p", [_vm._v("How do you get my consent?")]),
          _c("p", [
            _vm._v(
              "When you provide us with personal information to complete a transaction, verify your credit card, place an order, arrange for a delivery or return a purchase, we imply that you consent to our collecting it and using it for that specific reason only."
            )
          ]),
          _c("p", [
            _vm._v(
              "If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent, or provide you with an opportunity to say no."
            )
          ]),
          _c("p", [_vm._v("How do I withdraw my consent?")]),
          _c("p", [
            _vm._v(
              "If after you opt-in, you change your mind, you may withdraw your consent for us to contact you, for the continued collection, use or disclosure of your information, at anytime, by contacting us at info@justlifeinsurance.ca."
            )
          ]),
          _c("h2", { staticClass: "subtitle" }, [
            _vm._v("SECTION 3 – DISCLOSURE")
          ]),
          _c("p", [
            _vm._v(
              "We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service."
            )
          ]),
          _c("h2", { staticClass: "subtitle" }, [
            _vm._v("SECTION 4 – THIRD-PARTY SERVICES")
          ]),
          _c("p", [
            _vm._v(
              "In general, the third-party providers used by us will only collect, use and disclose your information to the extent necessary to allow them to perform the services they provide to us."
            )
          ]),
          _c("p", [
            _vm._v(
              "However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies in respect to the information we are required to provide to them for your purchase-related transactions."
            )
          ]),
          _c("p", [
            _vm._v(
              "For these providers, we recommend that you read their privacy policies so you can understand the manner in which your personal information will be handled by these providers."
            )
          ]),
          _c("p", [
            _vm._v(
              "In particular, remember that certain providers may be located in or have facilities that are located in a different jurisdiction than either you or us. If you elect to proceed with a transaction that involves the services of a third-party service provider, your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located."
            )
          ]),
          _c("p", [
            _vm._v(
              "As an example, if you are located in Canada and your transaction is processed by a payment gateway located in the United States, then your personal information used in completing that transaction may be subject to disclosure under United States legislation, including the Patriot Act."
            )
          ]),
          _c("p", [
            _vm._v(
              "Once you leave our store’s website or are redirected to a third-party website or application, you are no longer governed by this Privacy Policy or our website’s Terms of Service."
            )
          ]),
          _c("p", [_vm._v("Links")]),
          _c("p", [
            _vm._v(
              "When you click on links in our site, they may direct you away from our website. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements."
            )
          ]),
          _c("h2", { staticClass: "subtitle" }, [
            _vm._v("SECTION 5 – SECURITY")
          ]),
          _c("p", [
            _vm._v(
              "To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed."
            )
          ]),
          _c("h2", { staticClass: "subtitle" }, [
            _vm._v("SECTION 6 – AGE OF CONSENT")
          ]),
          _c("p", [
            _vm._v(
              "By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site."
            )
          ]),
          _c("h2", { staticClass: "subtitle" }, [
            _vm._v("SECTION 7 – CHANGES TO THIS PRIVACY POLICY")
          ]),
          _c("p", [
            _vm._v(
              "We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it."
            )
          ]),
          _c("p", [
            _vm._v(
              "If our store is acquired or merged with another company, your information may be transferred to the new owners."
            )
          ]),
          _c("h2", { staticClass: "subtitle" }, [
            _vm._v("QUESTIONS AND CONTACT INFORMATION")
          ]),
          _c("p", [
            _vm._v(
              "If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance Officer at info@justlifeinsurance.ca and include Re: Privacy Compliance Officer in your subject."
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0009ab3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0009ab3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/privacy/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0009ab3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/privacy/index.vue
// module chunks = 14